// Use $ instead of $ without replacing global $
(function ($) {

  $(document).ready(function () {

    var intro_logo = $('.intro-with-icons .icon-outer .logo-1 .img-outer img');
    objectFitImages(intro_logo);
  });

})(jQuery);
